module.exports = __webpack_public_path__ + "img/Flag_of_France.adfc9bcf.svg";